import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

/**
 * HorizontalDashIcon component for rendering an SVG icon with horizontal dashes (for dashboard page).
 *
 * @component
 * @param {Object} props - The properties of the component.
 * @param {number} [props.totalLines=5] - The total number of horizontal dashes.
 * @param {number} [props.linesWithColorA=3] - The number of lines with colorA.
 * @returns {JSX.Element} The HorizontalDashIcon component.
 */
function HorizontalDashIcon(props) {
  const {totalLines = 5, linesWithColorA = 3} = props;

  const colorA = '#00adb5';
  const colorB = '#bdd0d5';

  const colors = Array.from({length: totalLines}, (_, index) => (index < linesWithColorA ? colorA : colorB));

  const dashWidth = 800;
  const gapWidth = 90;
  const totalDashes = totalLines;
  const lineThickness = 200;

  const totalWidth = totalDashes * (dashWidth + gapWidth);
  const viewBox = `0 0 ${totalWidth + dashWidth * 2} 20`;

  const lines = [];
  for (let i = 0; i < totalDashes; i++) {
    const x = i * (dashWidth + gapWidth);
    const color = colors[i] || '#00adb5'; // Use provided colour or default

    lines.push(<line key={i} x1={x} y1="10" x2={x + dashWidth} y2="10" stroke={color} strokeWidth={lineThickness} />);
  }

  return (
    <SvgIcon {...props} viewBox={viewBox} fontSize="large">
      {lines}
    </SvgIcon>
  );
}

export default HorizontalDashIcon;
